
<template>
  <div>
    <div class="Navigation" id="indexScroll">
      <div class="contant clearfix">
        <span class="fl logo">MTMONE</span>
        <ul>
          <li @click="nav(1)" :class="{act:show==1}">首页</li>
          <li @click="nav(2)" :class="{act:show==2}">共享面料库</li>
          <li @click="nav(3)" :class="{act:show==3}">潮流版型库</li>
          <li @click="nav(4)" :class="{act:show==4}">海量智能制造商</li>
          <li @click="nav(5)" :class="{act:show==5}">定制精品</li>
          <li @click="nav(6)" :class="{act:show==6}">注册与加盟</li>
          <li @click="nav(7)" :class="{act:show==7}">关于</li>
        </ul>
        <div class="login">
          <span>登录:</span>
          <span class="store" @click="Mtm()">店铺</span>
          <span class="sheng" @click="bossMtm()">生产制造商</span>
        </div>
      </div>
    </div>
    <div class="contant">
      <h3>店铺注册</h3>
      <div class="clearfix AllInput">
        <span>手机号码:</span>
        <div class="Input">
          <Input v-model="phone" placeholder="请输入联系人手机" type="number" :border="false" />
        </div>
      </div>
      <div class="clearfix AllInput">
        <span>验证码:</span>
        <div class="yan">
          <div class="yanZheng">
            <Input v-model="Yanma" placeholder="请输入收到的验证码" :border="false" />
          </div>
          <span class="Ybtns" @click="getPin()" v-if="show">获取验证码</span>
          <span class="Nbtns" v-else>{{time}}秒后重发</span>
        </div>
      </div>
      <div class="clearfix AllInput">
        <span>品牌/店铺名称:</span>
        <div class="Input">
          <Input v-model="Compayname" placeholder="请输入品牌/店铺名称" :border="false" />
        </div>
      </div>
      <div class="clearfix AllInput">
        <span>账号类型:</span>
        <div class="Select">
          <Select v-model="zhangType" placeholder="请选择账号类型">
            <Option v-for="item in ShopType" :value="item.name" :key="item.name">{{ item.name }}</Option>
          </Select>
        </div>
      </div>
      <div class="clearfix AllInput">
        <span>所在地址:</span>
        <div class="Select">
          <div class="Sone">
            <Select v-model="province" placeholder="-省-" @on-change='nextOne($event)' :label-in-value='true'>
              <Option v-for="item in provinceList" :value="item.name" :label="item.name" :key="item.adcode">
                {{ item.name }}
              </Option>
            </Select>
          </div>
          <div class="Sone">
            <Select v-model="city" placeholder="-市-" @on-change='nextTwo($event)' :label-in-value='true'>
              <Option v-for="item in cityList" :value="item.name" :label="item.name" :key="item.name">
                {{ item.name }}
              </Option>
            </Select>
          </div>
          <div class="Sone">
            <Select v-model="area" placeholder="-区-" @on-change='nextThree($event)' :label-in-value='true'>
              <Option v-for="item in areaList" :value="item.name" :label="item.name" :key="item.name">{{ item.name }}
              </Option>
            </Select>
          </div>
        </div>
        <textarea placeholder="请填写详细地址" v-model="Address"></textarea>
      </div>
      <div class="clearfix AllInput">
        <span>联系人姓名:</span>
        <div class="Input">
          <Input v-model="UserName" placeholder="请输入联系人姓名" :border="false" />
        </div>
      </div>
      <div class="clearfix AllInput">
        <span>请设置密码:</span>
        <div class="Input">
          <Input v-model="password" type="password" password placeholder="6-20个字符，不能纯数字、字母" :border="false" />
        </div>
      </div>
      <div class="clearfix AllInput">
        <span>请确认密码:</span>
        <div class="Input">
          <Input v-model="AginPassword" type="password" password placeholder="请再次输入密码" :border="false" />
        </div>
      </div>
      <div class="clearfix check">
        <img src="../assets/img/check-a.png" v-if="check==false" @click="sign()" />
        <img src="../assets/img/check-b.png" v-if="check==true" @click="sign()" />
        <p>我已阅读并同意<span @click="toAgree()">《品牌/零售商注册协议》<span @click="toMtmRule()">《MTMONE平台规则》</span></span></p>
      </div>
      <div class="sumbit" @click="submit()">注册</div>
      <span class="login" @click="Mtm()">已有账号,请登录</span>
    </div>
    <Modal v-model="modal1" title="提示" @on-ok="ok" @on-cancel="cancel" :mask-closable='false' :loading='true'>
      <p>注册成功!</p>
      <p>登录地址为:{{successData.url}}</p>
      <!-- <p>租户为:{{successData.zuhu}}</p> -->
      <p>账号为:{{successData.account}}</p>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "",
      modal1: false,
      successData: {},
      Yanma: "",
      Compayname: "",
      zhangType: '',
      ShopType: [{
        name: "直营店"
      },
      {
        name: "加盟店"
      },

      ],
      password: '',
      AginPassword: '',
      UserName: '',
      check: false,
      Address: '',
      province: '',
      city: '',
      area: '',
      provinceList: [], //省
      cityList: [], //市
      areaList: [], //区
      show: true,
      time: 60,
      register2: true

    };
  },
  //调用函数
  methods: {
    nav(type) {
      this.$router.push({ path: "/" })
      window.sessionStorage.setItem("id", type)
    },
    ok() {
      // this.$Message.info('Clicked ok');
      window.open('http://s.mtmone.com/')
      location.reload()
      this.modal1 = true
    },
    cancel() {
      location.reload()
      // this.$Message.info('Clicked cancel');
    },
    sign() { //阅读协议
      this.check = !this.check
    },
    Mtm() { //跳转到登录页
      window.open('http://s.mtmone.com/')
    },
    bossMtm() {
      window.open('http://mfg.mtmone.com/')
    },
    toAgree() { //查看协议
      window.open('https://aax849ddj9.feishu.cn/file/boxcnmdIWtkhNe4ReGR2RFTjoHh')
    },
    toMtmRule() {
      window.open('https://aax849ddj9.feishu.cn/docs/doccnFPSTlssoeXa04X7h8Q7Dvh')
    },
    //获取验证码
    getPin() {
      let self = this;
      if (self.phone == '') {
        alert('请输入手机号')
        return
      };
      let params = {
        type: 2,
        telphone: self.phone
      }
      self.getAxios("/mtmone/Pin/SendPin", params).then(function (res) {
        if (res.data.status == 0) {
          alert(res.data.message)
        }
        self.show = false
        let i = 0
        let date = setInterval(function () {
          i++;
          self.time--;
          if (i == 60) {
            clearInterval(date)
            self.show = true;
          }
        }, 1000)
      });
    },
    //获取地址
    getAddress(item, index) {
      let self = this;
      let params = {
        citycode: item
      };
      self.getAxios("/mtmone/address/getaddress", params).then(function (res) {
        if (index == 0) {
          self.provinceList = res.data.data;
          return
        };
        if (index == 1) {
          self.cityList = res.data.data;
          return
        }
        if (index == 2) {
          self.areaList = res.data.data;
          return
        }

      });
    },
    nextOne(val) { //省
      this.getAddress(val.value, 1) //获取市
      this.areaList = [];
      this.city = "";
      this.area = "";
    },
    nextTwo(val) { //市
      if (val != undefined) this.getAddress(val.value, 2) //获取区
    },
    nextThree(val) { //区
    },
    submit() { //注册
      let self = this;
      if (self.phone == '') {
        alert('请输入手机号')
        return
      };
      if (self.Yanma == '') {
        alert('请输入验证码')
        return
      };
      if (self.Compayname == '') {
        alert('请输入生产制造商名称')
        return
      };
      if (self.zhangType == '') {
        alert('请选择账号类型')
        return
      };

      if (self.province == '' || self.city == '' || self.area == '') {
        alert('请选择所在地址')
        return
      };

      if (self.Address == '') {
        alert('请填写详细地址')
        return
      };
      let add = self.province + ',' + self.city + ',' + self.area + ',' + self.Address
      if (self.UserName == '') {
        alert('请输入联系人姓名')
        return
      };
      if (self.password == '') {
        alert('请输入密码')
        return
      };
      if (self.AginPassword != self.password) {
        alert('两次密码不一致,请重新输入')
        return
      };
      if (!self.check) {
        alert('请阅读并同意《品牌/零售商注册协议》')
        return
      };
      let params = {
        telphone: self.phone,
        pin: self.Yanma,
        storename: self.Compayname,
        accounttype: self.zhangType == '直营店' ? '1' : '2',
        address: add,
        contact: self.UserName,
        password: self.password
      }
      if (self.register2) {
        self.register2 = !self.register2
        self.postAxios("/mtmone/ShopRegister/ShopRegister", params).then(function (res) {
          self.register2 = !self.register2
          if (res.data.status == 1) {
            self.successData = res.data.data;
            self.modal1 = true;
            self.$Message.success(res.data.message);
            return
          }
          self.$Message.error(res.data.message);
        });
      }

    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.getAddress(100000, 0)
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    window.scrollTo(0, 0);
  },
  //组件加载
  components: {}
};
</script>
<style scoped lang="scss">
/* @import url(); 引入css类 */
.Navigation {
  height: 0.9rem;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  color: rgb(17, 16, 16);
  z-index: 999999;
  .contant {
    width: 17rem;
  }
  .logo {
    font-size: 0.36rem;
    line-height: 0.9rem;
    font-weight: 800;
    display: block;
  }

  ul {
    float: left;
    margin-top: 0.3rem;

    li {
      cursor: pointer;
      height: 0.34rem;
      line-height: 0.34rem;
      font-size: 0.16rem;
      color: rgb(17, 16, 16);
      float: left;
      padding: 0 0.02rem;
      margin-left: 0.15rem;
      // border-bottom: 0.02rem solid rgba($color: rgb(8, 8, 8), $alpha: 0.1)
    }

    .act {
      border-bottom: 0.02rem solid rgba($color: rgb(17, 16, 16), $alpha: 0.6);
    }

    li:hover {
      border-bottom: 0.02rem solid rgba($color: rgb(17, 16, 16), $alpha: 0.6);
    }
  }

  .login {
    float: right;
    margin-top: 0.16rem;
    position: absolute;
    top: 0;
    right: 0;

    span {
      color: rgb(17, 16, 16);
      font-size: 0.14rem;
      display: block;
      float: left;
      height: 0.14rem;
      line-height: 0.14rem;
    }

    .store {
      background: url("../assets/img/login-b2.png") no-repeat;
      background-size: 0.14rem 0.14rem;
      padding-left: 0.17rem;
      margin: 0 0.1rem;
      cursor: pointer;
    }

    .sheng {
      background: url("../assets/img/login-a2.png") no-repeat;
      background-size: 0.14rem 0.14rem;
      padding-left: 0.17rem;
      cursor: pointer;
    }
  }
}

h3 {
  width: 4.7rem;
  height: 0.5rem;
  margin: 0 auto;
  text-align: left;
  font-size: 0.3rem;
  color: #333;
  line-height: 0.5rem;
  font-weight: bold;
  margin-bottom: 0.35rem;
  margin-top: 0.2rem;
  padding-left: 0.4rem;
}
input::placeholder {
  font-size: 0.14rem;
}
.AllInput {
  width: 5rem;
  min-height: 0.42rem;
  margin: 0 auto;
  margin-bottom: 0.2rem;

  > span {
    float: left;
    display: block;
    min-width: 1rem;
    color: #333;
    font-size: 0.14rem;
    text-align: right;
    line-height: 0.42rem;
  }

  .Input {
    width: 3.6rem;
    float: right;
    height: 0.42rem;
    border: 0.01rem solid #e3e3e3;
  }

  .Select {
    float: right;
    width: 3.6rem;
    height: 0.42rem;

    select {
      width: 100%;
    }

    .Sone {
      width: 33.33%;
      float: left;
      text-align: center;
    }
  }

  textarea {
    width: 3.6rem;
    float: right;
    height: 0.85rem;
    resize: none;
    border: 1px solid #e3e3e3;
    margin-top: 0.12rem;
    border-radius: 0.04rem;
    padding: 0.1rem;
    font-size: 0.14rem;
    color: #adadad;
  }

  .yan {
    float: right;
    width: 3.6rem;
    height: 0.42rem;
    border: 0.01rem solid #e3e3e3;

    .yanZheng {
      float: left;
      width: 2.3rem;

      input {
        border: none;
      }
    }

    .Ybtns {
      float: right;
      width: 1.2rem;
      color: #2376ff;
      font-size: 0.14rem;
      text-align: center;
      cursor: pointer;
      line-height: 0.42rem;
      border-left: 0.01rem solid #e3e3e3;
    }

    .Nbtns {
      float: right;
      width: 1.2rem;
      color: #adadad;
      font-size: 0.14rem;
      text-align: center;
      cursor: pointer;
      line-height: 0.42rem;
      border-left: 0.01rem solid #e3e3e3;
    }
  }
}

.check {
  margin: 0 auto;
  margin-top: 0.36rem;
  width: 6rem;
  height: 0.36rem;
  line-height: 0.16rem;
  display: flex;
  justify-content: center;

  img {
    width: 0.16rem;
    height: 0.16rem;
    float: left;
    display: block;
  }

  p {
    float: left;
    margin-left: 0.08rem;
    font-size: 0.14rem;
    color: #333;

    span {
      color: #2376ff;
      cursor: pointer;
    }
  }
}

.sumbit {
  width: 3.6rem;
  height: 0.48rem;
  text-align: center;
  line-height: 0.48rem;
  background: #333;
  color: #fff;
  font-size: 0.14rem;
  margin: 0 auto;
  margin-top: 0.4rem;
  cursor: pointer;
}

.login {
  color: #2376ff;
  font-size: 0.14rem;
  text-align: center;
  margin: 0 auto;
  display: block;
  cursor: pointer;
  margin-top: 0.2rem;
  margin-bottom: 0.78rem;
}
</style>
<style>
.ivu-input {
  border: none;
  height: 0.39rem !important;
}

.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 0.39rem !important;
  line-height: 0.39rem !important;
}

.ivu-select-single .ivu-select-selection {
  height: 0.39rem !important;
  line-height: 0.39rem !important;
}

.ivu-input:focus {
  border: none !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/joinShop.vue